import { Pipe, PipeTransform } from '@angular/core';






@Pipe({
  name: 'secondsToTimeSpan'
})
export class SecondsToTimeSpan implements PipeTransform {
  transform(value: number): any {

    const hours = Math.floor(value / 3600);
    value %= 3600;
    const minutes = Math.floor(value / 60);
    const seconds = Math.floor(value % 60);

    

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
}
